import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import telusConvivaAnalytics from "../../../shared/utils/convivaAnalytics";
import { trapFocus } from "../../../shared/utils";
import { useReducers } from "../../../shared/hooks/useReducer";
import constants from "../../../shared/constants";
import PlayerConstants from "../../../shared/constants/player";

const { REDUCER_TYPE } = constants;
const { BINGE_WATCH_TIMER } = PlayerConstants;

export const useBingeWatchEffect = (
  type,
  playNextProgram,
  nextProgram,
  bingeWatchInProgress,
  remainingTime,
  bingeWatchCountdownTime,
  bingeWatchTimer,
  setBingeWatchTimer,
  setShowNextEpisodeCard,
  videoExitThreshold,
  loadNextProgram,
  loadNextEpisodeCallback,
  autoPlayTimer,
  isLivePlayback = false,
  isSportSeriesRecording = false,
  isTeamRecording = false,
  handleAVSStopContent
) => {
  const history = useHistory();
  const { featureToggles } = useReducers(REDUCER_TYPE.APP);
  const { isDynatraceTrackingEnabled } = featureToggles;

  // Using 98 percent or at minimum of 20 secs (whichever is greater) before the end of stream for displaying binge watch panel
  const bingeWatchThresholdTime =
    bingeWatchCountdownTime && Math.floor(bingeWatchCountdownTime) > BINGE_WATCH_TIMER
      ? bingeWatchCountdownTime
      : BINGE_WATCH_TIMER;

  useEffect(() => {
    if (type === "LIVE" || isLivePlayback) {
      return;
    }
    if (
      playNextProgram &&
      nextProgram &&
      !bingeWatchInProgress &&
      remainingTime > 0 &&
      remainingTime <= bingeWatchThresholdTime &&
      !bingeWatchTimer &&
      !isSportSeriesRecording &&
      !isTeamRecording
    ) {
      remainingTime < BINGE_WATCH_TIMER ? setBingeWatchTimer(remainingTime - 1) : setBingeWatchTimer(BINGE_WATCH_TIMER);
      setShowNextEpisodeCard(true);
    }

    if (
      (!playNextProgram || (playNextProgram && !nextProgram) || isSportSeriesRecording || isTeamRecording) &&
      remainingTime &&
      remainingTime < videoExitThreshold
    ) {
      if (isSportSeriesRecording || isTeamRecording) {
        handleAVSStopContent();
      }
      history.goBack();
    }

    if (
      playNextProgram &&
      nextProgram &&
      remainingTime &&
      Math.floor(remainingTime) <= videoExitThreshold &&
      !isSportSeriesRecording &&
      !isTeamRecording
    ) {
      telusConvivaAnalytics.onPlayNextProgram();
      loadNextProgram && loadNextProgram(true, () => loadNextEpisodeCallback(true, null, isDynatraceTrackingEnabled));
    }
    if (remainingTime > bingeWatchThresholdTime) {
      if (autoPlayTimer.current) {
        clearTimeout(autoPlayTimer.current);
        autoPlayTimer.current = null;
      }
      setBingeWatchTimer(0);
      setShowNextEpisodeCard(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingTime]);

  useEffect(() => {
    if (playNextProgram && bingeWatchTimer) {
      if (!autoPlayTimer.current) {
        autoPlayTimer.current = setTimeout(() => {
          telusConvivaAnalytics.onPlayNextProgram();
          loadNextProgram &&
            loadNextProgram(true, () => loadNextEpisodeCallback(true, null, isDynatraceTrackingEnabled));
          setShowNextEpisodeCard(false);
        }, bingeWatchTimer * 1000);
      }
    }
    if (!playNextProgram && autoPlayTimer.current) {
      clearTimeout(autoPlayTimer.current);
    }
    if (bingeWatchInProgress) {
      clearTimeout(autoPlayTimer.current);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playNextProgram, bingeWatchInProgress, bingeWatchTimer]);
};

export const useNextEpisodeCardEffect = (
  showNextEpisodeCard,
  bingeWatchCard,
  setVideoControlsStyle,
  isSportSeriesRecording,
  isTeamRecording
) => {
  useEffect(() => {
    if (
      showNextEpisodeCard &&
      bingeWatchCard &&
      bingeWatchCard.current &&
      !isSportSeriesRecording &&
      !isTeamRecording
    ) {
      setVideoControlsStyle({ opacity: 0, visibility: "hidden" });
      trapFocus(bingeWatchCard.current);
      bingeWatchCard.current.focus();
    }
  }, [showNextEpisodeCard, bingeWatchCard, setVideoControlsStyle, isSportSeriesRecording, isTeamRecording]);
};
